import styled from 'styled-components'

const ReviewCount = styled.span`
  ::before {
    content: '(';
  }

  ::after {
    content: ')';
  }

  font-size: ${props => props.theme.font.stack.caption['font-size']};
  margin: 0 0 5px 5px;
`

const StarRatingWrapper = styled.div`
  display: inline-block;
  cursor: pointer;
`

export { ReviewCount, StarRatingWrapper }
